import { DaDeviationThumbAttrs, DaDeviationThumbOptions } from '../deviation-thumb';

function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}

export function useSize(
  deviationMediaService,
  attrs: DaDeviationThumbAttrs,
  options: DaDeviationThumbOptions,
  containerWidth: number
) {
  const width = attrs.width ?? undefined;
  const height = attrs.height ?? undefined;
  containerWidth = containerWidth - 32;

  const fv = deviationMediaService.getLargestFullview(attrs.deviation);
  if (!fv) {
    return {
      width: 50,
      height: 50,
    };
  }
  const ratio = (fv.height ?? 0) / (fv.width ?? 0);

  // Set dims
  if (!isNaN(width as number) && !isNaN(height as number)) {
    return {
      width: clamp(clamp(attrs.width!, 0, options.maxWidth ?? Infinity), 0, containerWidth),
      height: clamp(attrs.height!, 0, options.maxHeight ?? Infinity),
    };
  }

  // Width only
  if (!isNaN(width as number) && isNaN(height as number)) {
    return {
      width: clamp(clamp(attrs.width!, 0, options.maxWidth ?? Infinity), 0, containerWidth),
      height: clamp(attrs.width! * ratio, 0, options.maxHeight ?? Infinity),
    };
  }

  // Defaults
  return {
    width: clamp(clamp(options.defaultWidth, 0, options.maxWidth ?? Infinity), 0, containerWidth),
    height: clamp(options.defaultWidth * ratio, 0, options.maxHeight ?? Infinity),
  };
}
